module.exports = __webpack_public_path__ + "img/scene10_1.b98cc631.svg";